import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Router } from '@angular/router';
import { RoutePaths } from '../shared/constants/route-paths.constant';
import { DeviceDetector } from '../shared/services/device-detector.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { M365AppsRouteGuard } from './m365-apps.route-guard';

@Injectable({
    providedIn: 'root'
})
export class MultiPlatM365AppsRouteGuard extends M365AppsRouteGuard implements CanActivate, CanLoad {

    private readonly isMobile: boolean;
    constructor(
        private readonly deviceDetector: DeviceDetector,
        capabilitiesService: CapabilitiesService,
        router: Router
    ) {
        super(capabilitiesService, router);
        this.isMobile = this.deviceDetector.isMobileDevice();
    }

    public canActivate(route: ActivatedRouteSnapshot) {
        const firstUrlSegment = route?.url[0]?.path ?? '';
        const mobilePath = `/${RoutePaths.MobileChat}`;
        if (this.isMobile && firstUrlSegment === RoutePaths.Chat) {
            this.router.navigate([mobilePath], {skipLocationChange: true});
            return false;
        }
        return super.canActivate(route);
    }

    public canLoad() {
        if (this.isMobile) {
            return true;
        }
        return super.canLoad();
    }
}
